// Initial values for EmailReportModal form
export const emailFormInitialValues = {
    emailAddresses: ''
}

export default emailFormInitialValues